import axios from "../plugins/parseAxios";
export class FileUploadAPI {
  static async upload(data, fileType = ".jpg", isBase64 = false) {
    const textNameRandom16Bit = this.get16Bit()
    let base64
    if (isBase64) {
      const fileData = data;
      const resp = await fetch(fileData);
      const fblob = await resp.blob();
      return axios.post("files/" + textNameRandom16Bit + ".png", fblob );
    }
    else
      return axios.post("files/" + textNameRandom16Bit + "." + fileType, data);
  }
  static get16Bit() {
    const chars = [..."ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"];
    return [...Array(10)].map(i => chars[Math.random() * chars.length | 0]).join``;
  }
}
